/* import __COLOCATED_TEMPLATE__ from './loan-balances.hbs'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { Target } from '@banking/ui/utils/launchpad-cdp-events';
import Component from '@glimmer/component';
import { action } from '@ember/object';
let LoanBalances = (_class = class LoanBalances extends Component {
  get isMcaGlobal() {
    return this.args.isMcaGlobal;
  }
  get loanOffers() {
    const offers = [];
    this.args.loansAndOffers.forEach(loan => {
      if (loan?.loanOfferDetails) {
        offers.push(loan.loanOfferDetails);
      }
    });
    return offers;
  }
  get loansAndOffers() {
    return this.args.loansAndOffers.map(loan => ({
      ...loan,
      shouldShowLoanRow: loan.hasLoan && !loan.isInactive || !loan.loanOfferDetails
    }));
  }
  goToLoanOffer(offer, event) {
    event.stopPropagation();
    this.args.goToCapitalLoanOffer(offer.offerSetId, {
      target: Target.BalanceCardViewOffer,
      unitToken: offer.unitToken
    });
  }
  goToLoan(customerToken, unitToken) {
    this.args.goToCapitalLoan({
      customerToken,
      unitToken
    });
  }
}, (_applyDecoratedDescriptor(_class.prototype, "goToLoanOffer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLoanOffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToLoan", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLoan"), _class.prototype)), _class);
export { LoanBalances as default };